import * as angular from 'angular';

export class BackToDashboardService {
    public static $inject = [];
    public dashboardLink: string;

    private backStorageKey = 'back_link';

    constructor() {
        this.setBackDashboardFromStorage();
    }

    public trySetLink(link: string) {
        const dashboard = link ? this.getDashboardNameByLink(link) : '';
        if (dashboard) {
            sessionStorage.setItem(this.backStorageKey, link);
            this.setBackDashboardFromStorage();
        }
    }

    private setBackDashboardFromStorage() {
        this.dashboardLink = sessionStorage.getItem(this.backStorageKey);
    }

    private getDashboardNameByLink(link: string): string {
        if (link.match(siteRetailerHomeUrl)) {
            return 'Retailer';
        }
        return '';
    }
}

angular
    .module('app.common')
    .service('backToDashboardService', BackToDashboardService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/services/back-to-dashboard.service.ts